import { TitleH3, TitleH4 } from "@/components/shared/public";
import { PropsWithChildren } from "react";

const Section = ({
  title,
  topic,
  children,
}: PropsWithChildren<{ title?: string; topic?: string }>) => {
  return (
    <div className="text-ring flex flex-col gap-5">
      {title && <TitleH3 title={title} />}
      {topic && <TitleH4 title={topic} />}
      {children}
    </div>
  );
};

export default Section;
